var generateComponentTheme = function generateComponentTheme(_ref) {
  var colors = _ref.colors,
    typography = _ref.typography,
    forms = _ref.forms;
  return {
    contentFontFamily: typography.fontFamily,
    linkColor: colors.link,
    contentColor: colors.textDarkest,
    rceMinHeight: forms.inputHeightMedium
  };
};
export default generateComponentTheme;